export default function RenderLogo() {
  return (
    <div className=" text-blue-500 flex">
      <div className="flex space-x-1 items-center">
        <span>
          <img src="/alurkerja-logo.svg" alt="" height={24} width={24} />
        </span>
        <span className="bg-[#D7E5FF] text-xs text-[#0B4ED3] font-semibold py-1 px-2 rounded">App</span>
      </div>
    </div>
  );
}
